import React, { useState, useEffect } from "react";
import * as api from "../api";
import { C, R, F, numeric } from "../theme";
import { Icon } from "../icons";
import { Btn, Card } from "./UI";

// ─── Estimation Component ────────────────────────────────────────────────────
function PriceEstimator({ t, pricing, setView }) {
  const [quantities, setQuantities] = useState({});
  const [show, setShow] = useState(false);
  const [articles, setArticles] = useState([
    { name: "Chemise", price: 1000 }, { name: "Pantalon", price: 1000 },
    { name: "Robe", price: 1500 }, { name: "Costume (2 pièces)", price: 3000 },
    { name: "Veste", price: 2000 }, { name: "Manteau", price: 3000 },
    { name: "T-shirt", price: 500 }, { name: "Jupe", price: 1000 },
    { name: "Drap", price: 1500 }, { name: "Couette", price: 3000 },
  ]);

  useEffect(() => {
    api.getArticles().then(data => {
      if (data && data.length) setArticles(data.map(a => ({ name: a.name, price: parseFloat(a.price) })));
    }).catch(() => {});
  }, []);

  const total = articles.reduce((s, a) => s + (quantities[a.name] || 0) * a.price, 0);

  // Bouton rond de quantité (− / +)
  const stepBtn = (variant) => ({
    width: 28, height: 28, borderRadius: R.md, flexShrink: 0,
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    border: `1px solid ${variant === "add" ? C.navy : C.border}`,
    background: variant === "add" ? C.navy : C.surface,
    color: variant === "add" ? C.inkOn : C.inkMuted,
    cursor: "pointer",
    transition: "background .15s ease, border-color .15s ease",
  });

  if (!show) {
    return (
      <div style={{ display: "flex", justifyContent: "center", padding: "20px 0" }}>
        <Btn variant="white" icon="percent" onClick={() => setShow(true)}>
          {t.estimateTitle}
        </Btn>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 900, margin: "0 auto", padding: "36px 20px" }}>
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <h2 style={{
          fontSize: F.size["3xl"], fontWeight: F.weight.semi,
          color: C.ink, letterSpacing: "-.02em", marginBottom: 6,
        }}>
          {t.estimateTitle}
        </h2>
        <p style={{ fontSize: F.size.md, color: C.inkMuted }}>{t.estimateSubtitle}</p>
      </div>

      <div style={{
        display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(210px, 1fr))",
        gap: 10, marginBottom: 20,
      }}>
        {articles.map(a => {
          const qty = quantities[a.name] || 0;
          return (
            <Card
              key={a.name}
              style={{
                padding: 12, display: "flex", justifyContent: "space-between",
                alignItems: "center", gap: 10,
                borderColor: qty > 0 ? C.borderStrong : C.border,
              }}
            >
              <div style={{ minWidth: 0 }}>
                <div className="truncate" style={{ fontSize: F.size.md, fontWeight: F.weight.medium, color: C.ink }}>
                  {a.name}
                </div>
                <div style={{ fontSize: F.size.sm, color: C.inkMuted, marginTop: 1, ...numeric }}>
                  {a.price.toLocaleString()} F
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: 6, flexShrink: 0 }}>
                <button
                  type="button"
                  title={`Retirer un ${a.name}`}
                  aria-label={`Retirer un ${a.name}`}
                  onClick={() => setQuantities(p => ({ ...p, [a.name]: Math.max(0, (p[a.name] || 0) - 1) }))}
                  style={stepBtn("remove")}
                >
                  <Icon name="remove" size={14} />
                </button>
                <span style={{
                  minWidth: 22, textAlign: "center",
                  fontSize: F.size.md, fontWeight: F.weight.semi, color: C.ink, ...numeric,
                }}>
                  {qty}
                </span>
                <button
                  type="button"
                  title={`Ajouter un ${a.name}`}
                  aria-label={`Ajouter un ${a.name}`}
                  onClick={() => setQuantities(p => ({ ...p, [a.name]: (p[a.name] || 0) + 1 }))}
                  style={stepBtn("add")}
                >
                  <Icon name="add" size={14} color={C.inkOn} />
                </button>
              </div>
            </Card>
          );
        })}
      </div>

      {total > 0 && (
        <Card className="animate-fadeInUp" style={{ padding: 20, textAlign: "center" }}>
          <div style={{ fontSize: F.size.base, color: C.inkMuted, marginBottom: 4 }}>{t.estimateTotal}</div>
          <div style={{
            fontSize: F.size["3xl"], fontWeight: F.weight.bold,
            color: C.ink, letterSpacing: "-.02em", marginBottom: 14, ...numeric,
          }}>
            {total.toLocaleString()} FCFA
          </div>
          <Btn icon="order" onClick={() => setView("order")}>{t.estimateCta}</Btn>
        </Card>
      )}
    </div>
  );
}

export default PriceEstimator;
